'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SvgContainer = require('./SvgContainer');

var _SvgContainer2 = _interopRequireDefault(_SvgContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarOutline = function CalendarOutline(props) {
  return _react2.default.createElement(
    _SvgContainer2.default,
    {
      height: props.height,
      width: props.width,
      color: props.color,
      onClick: props.onClick,
      rotate: props.rotate ? 1 : 0,
      shake: props.shake ? 1 : 0,
      beat: props.beat ? 1 : 0,
      className: props.className
    },
    _react2.default.createElement(
      'svg',
      { style: props.style, className: props.cssClasses, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 512 512' },
      props.title ? _react2.default.createElement(
        'title',
        null,
        props.title
      ) : '',
      _react2.default.createElement('rect', { fill: 'none', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '32', x: '48', y: '80', width: '416', height: '384', rx: '48' }),
      _react2.default.createElement('circle', { cx: '296', cy: '232', r: '24' }),
      _react2.default.createElement('circle', { cx: '376', cy: '232', r: '24' }),
      _react2.default.createElement('circle', { cx: '296', cy: '312', r: '24' }),
      _react2.default.createElement('circle', { cx: '376', cy: '312', r: '24' }),
      _react2.default.createElement('circle', { cx: '136', cy: '312', r: '24' }),
      _react2.default.createElement('circle', { cx: '216', cy: '312', r: '24' }),
      _react2.default.createElement('circle', { cx: '136', cy: '392', r: '24' }),
      _react2.default.createElement('circle', { cx: '216', cy: '392', r: '24' }),
      _react2.default.createElement('circle', { cx: '296', cy: '392', r: '24' }),
      _react2.default.createElement('path', { fill: 'none', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '32', strokeLinecap: 'round', d: 'M128 48v32M384 48v32' }),
      _react2.default.createElement('path', { fill: 'none', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '32', d: 'M464 160H48' })
    )
  );
};

CalendarOutline.defaultProps = {
  // style
  style: {},
  color: '#000000',
  height: '22px',
  width: '22px',
  cssClasses: '',
  title: '',

  // animation
  shake: false,
  beat: false,
  rotate: false
};

CalendarOutline.propTypes = {
  // style
  style: _propTypes2.default.object,
  color: _propTypes2.default.string,
  height: _propTypes2.default.string,
  width: _propTypes2.default.string,
  cssClasses: _propTypes2.default.string,
  title: _propTypes2.default.string,

  // animation
  shake: _propTypes2.default.bool,
  beat: _propTypes2.default.bool,
  rotate: _propTypes2.default.bool,

  // functions
  onClick: _propTypes2.default.func
};

exports.default = CalendarOutline;
module.exports = exports['default'];
//# sourceMappingURL=CalendarOutline.js.map